import { useForm } from 'react-hook-form';
import { useNavigate } from 'react-router-dom';
import Form from 'react-bootstrap/Form';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Button from '@mui/material/Button';
import Stack from '@mui/material/Stack';
import CircularProgress from '@mui/material/CircularProgress';
import toast from 'react-hot-toast';
import { postRequest } from '../../../lib/api';
import { useContext, useState } from 'react';
import { AuthContext } from '../../../authContext/context';
import BreadcrumbsWrapper from '../../../components/breadcrumbs';

export default function CreateUserGroup() {
  const {
    register,
    handleSubmit,
    formState: { errors },
    reset
  } = useForm();

  const navigate = useNavigate();
  const authCtx = useContext(AuthContext);
  const [loading, setLoading] = useState(false);

  const onSubmit = async (data) => {
    setLoading(true);
    try {
      const payload = {
        title: data.title,
        is_default: !!data.is_default
      };

      const response = await postRequest('private/createUserGroup', payload, authCtx.token);

      if (response?.status === 200 || response?.success) {
        //toast.success('User Group created successfully!');
        reset();
        navigate('/user-groups');
      } else {
        toast.error(response?.message || 'User Group creation failed');
      }
    } catch (err) {
      console.error('User group creation error:', err);
      toast.error(err?.message || 'Something went wrong');
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <BreadcrumbsWrapper
        items={[
          { label: 'Dashboard', path: '/dashboard' },
          { label: 'User Groups', path: '/user-groups' },
          { label: 'Add User Group', path: '' },
        ]}
      />
      <br></br>
      <div className="page-header">
        <h1 className="mt-0">Add New User Group</h1>
      </div>

      <div className="page-top-formview mb-3">
        <Form onSubmit={handleSubmit(onSubmit)}>
          {/* Group Information */}
          <Row className="mb-3">
            <Form.Group as={Col} controlId="title">
              <Form.Label>Group Name</Form.Label>
              <Form.Control
                type="text"
                placeholder="Enter group name"
                {...register('title', { required: 'Group name is required' })}
                isInvalid={!!errors.title}
              />
              <Form.Control.Feedback type="invalid">
                {errors.title?.message}
              </Form.Control.Feedback>
            </Form.Group>
          </Row>

          {/* Default Group Checkbox */}
          <Row className="mb-3">
            <Form.Group as={Col}>
              <Form.Check
                type="checkbox"
                label="Set as Default Group"
                {...register('is_default')}
              />
            </Form.Group>
          </Row>

          <Stack direction="row" spacing={2}>
            <Button variant="outlined" color="inherit" type="button" onClick={() => navigate('/user-groups')}>
              Cancel
            </Button>
            <Button variant="contained" className='red-bg red-button text-capitalize' type="submit" disabled={loading}>
              {loading ? <CircularProgress size={20} color="inherit" /> : 'Submit'}
            </Button>
          </Stack>
        </Form>
      </div>
    </>
  );
}